import { render } from "./FooterPart.vue?vue&type=template&id=6b8cbbe0"
import script from "./FooterPart.vue?vue&type=script&lang=js"
export * from "./FooterPart.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__